<template>
    <div class="row mb-5">
      <div class="col-md mb-4">
        <h2>Make user admin</h2>
        <form @submit.prevent="makeAdmin">
          <div class="form-outline mb-4">
            <input type="email" v-model="email" id="email" class="form-control" required />
            <label class="form-label" for="email">Email address</label>
          </div>
          <button type="submit" class="btn btn-primary btn-block">Make admin</button>
        </form>
        <p class="mt-3" :class="{ 'text-danger': error, 'text-success': !error }">{{ response }}</p>  
      </div>
    </div>
</template>

<script>
import { makeUserAdmin } from '../../services/auth-service'

export default {
  data() {
    return {
      email: "",
      response: "",
      error: false
    };
  },
  methods: {
    makeAdmin() {
      makeUserAdmin(this.email)
        .then(res => {
          console.log(res)
          this.error = false;
          this.response = res.data.msg
        })
        .catch(err => {
          console.log(err)
          this.error = true;
          this.response = "An error occurred"
        })
    },
  }
};
</script>